import { Button, Text } from 'pcln-design-system';
import React, { useContext } from 'react';
import analytics from '../analytics/analytics';
import { createBasketRequest } from '../graphQLRequest/createBasketRequest';
import { ChatbotDataContext } from '../context/ChatbotDataContext';
export const BookHotelNowButton = props => {
  const {
    cguid,
    rguid,
    itemKey,
    priceKey,
    nightlyRateIncludingTaxesAndFees,
    minCurrencyCode,
    minCurrencyCodeSymbol,
    buttonProps
  } = props;
  const {
    isMobile
  } = useContext(ChatbotDataContext);
  return React.createElement(Button, Object.assign({}, buttonProps, {
    onClick: function (event) {
      event.preventDefault();
      event.stopPropagation();
      analytics.log(Object.assign({
        label: 'HotelSearchResult',
        hotelId: props.hotelId,
        message: 'HOTEL_CHECKOUT_LINK_CLICKED'
      }, props === null || props === void 0 ? void 0 : props.args));
      createBasketRequest({
        appc: isMobile ? 'MOBILEWEB' : 'DESKTOP',
        cguid,
        rguid,
        hotelOptions: {
          itemKey,
          priceKey,
          nightlyRateIncludingTaxesAndFees,
          minCurrencyCode,
          minCurrencyCodeSymbol
        }
      });
    }
  }), React.createElement(Text, {
    bold: true,
    fontSize: 0
  }, "Book Now"));
};
BookHotelNowButton.defaultProps = {
  buttonProps: {},
  cguid: '',
  rguid: '',
  itemKey: '',
  priceKey: '',
  nightlyRateIncludingTaxesAndFees: '',
  minCurrencyCode: 'USD',
  minCurrencyCodeSymbol: '$'
};